module.exports = __webpack_public_path__ + "static/media/text-wide.4eb8777b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/text-wide.svg
// module id = 209
// module chunks = 0